import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import _isEqual from 'lodash.isequal';
import {
  addScrollListener,
  fireGaOnblur,
  removeScrollListener,
  removeFireGaOnblur,
  fireGA4Script,
  fireGA4WithDataObject,
} from 'utils/common';
import { getPrcCookieValue } from 'utils/primeUtil';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  setPageConfigAndSendIBeatCall,
  setIbeattrack,
} from 'utils/iBeatConfig';
import ElementInView from 'components_v2/common/ElementInView/ElementInView';
import PEEntryNudge from 'components_v3/PEEntryNudge/PEEntryNudge.tsx';
// import UtilityBeltV2 from 'components_v2/common/UtilityBeltV2/UtilityBeltV2';
// import { utilityBeltWrapperStyle } from 'components_v2/common/UtilityBeltV2/UtilityBeltV2.style';
// CARD-3692: temporary disabled
// import { getUtilityBeltData } from 'components_v2/common/UtilityBeltV2/redux';
import ToipRowLayout from '../ToipRowLayout';
import LongCard from '../LongCard';
import ThreeCard from '../ThreeCard';
import BrowseByFeed from '../BrowseByFeed/browseByFeed';
import MostAnalytics from '../MostAnalytics/MostAnalytics';
import s from './ToipHomepage.scss';
// import NewscardComponent from '../../../../../components_v2/common/InitNewscardComponents/LoadableNewsCardComponent';
import {
  // TOI_PLUS_HOMEPAGE_CARDCMS_URL,
  // WEB_INDIA_HP_GA_CAT,
  TOI_LIVE_DOMAIN,
} from '../../../../../constants/index';

function ToipHomePage(props) {
  const {
    // cardsInsertsLite,
    homePageData,
    params,
    userData,
    isWapView,
    location,
    // showCollage,
    peEntryNudgeData,
    // getUtilityData,
    // utilityBeltData,
  } = props;
  const currentScroll = useRef(0);
  const gaActionClick = 'Print_listing_Click';
  const gaCategory = isWapView ? 'wap-Prime-Home' : 'web-Prime-Home';

  const getScrollPercentage = percentage => {
    if (currentScroll.current < percentage) {
      currentScroll.current = percentage;
    }
  };

  const sendScrollDepthGAEvent = () => {
    if (typeof window !== 'undefined') {
      analyticsWrapper(
        'ga',
        'send',
        'event',
        'web_scrolldepth_TOIPlus',
        Math.ceil(currentScroll.current),
        window.location.href,
      );
    }
  };
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const pageViewUrl = `${TOI_LIVE_DOMAIN}${location}`;
      analyticsWrapper('ga', 'send', 'pageview', pageViewUrl);
      fireGA4WithDataObject(
        fireGA4Script({
          isToipLayout: true,
          page_template: 'TOIPlus Landing',
        }) || {},
      );
    }
    setIbeattrack({
      author: '',
      contentType: 20,
      msid: '',
      planStatus: getPrcCookieValue(),
      publishedDate: '',
    });
    setPageConfigAndSendIBeatCall();
    addScrollListener('.toiplushomepage', getScrollPercentage);
    fireGaOnblur(sendScrollDepthGAEvent);

    return () => {
      removeScrollListener('.toiplushomepage', getScrollPercentage);
      removeFireGaOnblur(sendScrollDepthGAEvent);
    };
  }, []);

  // CARD-3692: temporary disabled
  // useEffect(() => {
  //   // const apiParam = {
  //   //   user_prime_status: window.App.state.isPrime ? 'prime' : 'non-prime',
  //   //   code: '/homepage',
  //   // };
  //   // getUtilityData(apiParam);
  // }, []);

  // const loadJpodSection = divStr => (
  //   <NewscardComponent
  //     isWapView={isWapView}
  //     cardsInsertsLite={cardsInsertsLite.inserts[divStr]}
  //     slot={divStr}
  //     apiUrl={TOI_PLUS_HOMEPAGE_CARDCMS_URL}
  //     tokens={cardsInsertsLite.whoami && cardsInsertsLite.whoami.tokens}
  //     campaignName={
  //       cardsInsertsLite.inserts[divStr] &&
  //       cardsInsertsLite.inserts[divStr].campaign_name
  //     }
  //     location={location}
  //     showCollage={showCollage}
  //     gaCat={WEB_INDIA_HP_GA_CAT}
  //     showBottomIntersection
  //     toipLayout
  //     isToiplus
  //     slidesToShow={3}
  //     pageName="ToiplusHome"
  //   />
  // );

  const getPeEntryNudgeData = () =>
    peEntryNudgeData?.[`prc${userData?.prcValue}`];

  let componentReturned;
  return (
    homePageData &&
    homePageData.map((sectionItem = {}, indexVal) => {
      switch (sectionItem.tn) {
        // case 'signals_utilitybelt': {
        //   componentReturned = (
        //     <UtilityBeltV2
        //       utilityBeltInfo={utilityBeltData}
        //       pageCode="prime_hp"
        //       webText="Click for news and views curated for you"
        //       mwebText="Click for news and views"
        //       styles={utilityBeltWrapperStyle}
        //       slidesToShow={isWapView ? 4 : 10}
        //       slidesToScroll={2}
        //       isWapView={isWapView}
        //     />
        //   );
        //   break;
        // }
        case 'tpcol_8_4_layout': {
          componentReturned = (
            <ToipRowLayout data={sectionItem} userData={userData} />
          );
          break;
        }
        case 'tpluslongcard': {
          componentReturned = (
            <LongCard data={sectionItem} userData={userData} />
          );
          break;
        }

        // case 'jpodsection0': {
        //   componentReturned =
        //     cardsInsertsLite &&
        //     cardsInsertsLite.inserts &&
        //     cardsInsertsLite.inserts['div-0'];
        //   if (componentReturned) componentReturned = loadJpodSection('div-0');
        //   break;
        // }
        // case 'jpodsection1': {
        //   componentReturned =
        //     cardsInsertsLite &&
        //     cardsInsertsLite.inserts &&
        //     cardsInsertsLite.inserts['div-1'];
        //   if (componentReturned) componentReturned = loadJpodSection('div-1');
        //   break;
        // }
        // case 'jpodsection2': {
        //   componentReturned =
        //     cardsInsertsLite &&
        //     cardsInsertsLite.inserts &&
        //     cardsInsertsLite.inserts['div-2'];
        //   if (componentReturned) componentReturned = loadJpodSection('div-2');
        //   break;
        // }
        case 'browsebyfeed': {
          componentReturned = (
            <BrowseByFeed
              data={sectionItem}
              key={indexVal}
              userData={userData}
            />
          );
          break;
        }
        case 'tplistingthreecard': {
          componentReturned = (
            <ThreeCard data={sectionItem} userData={userData} />
          );
          break;
        }
        case 'tpgamecard': {
          componentReturned = '';
          break;
        }
        case 'peEntryNudge': {
          componentReturned = peEntryNudgeData.activeWidget === 'yes' && (
            <ElementInView
              gaCategory={gaCategory}
              gaAction="Print_listing_View"
              gaLabel={`Ps-${
                userData?.prcValue === 0 ? -1 : userData?.prcValue
              }`}
            >
              <PEEntryNudge
                isWapView={isWapView}
                data={getPeEntryNudgeData()}
                userData={userData}
                gaCategory={gaCategory}
                gaAction={gaActionClick}
              />
            </ElementInView>
          );
          break;
        }
        case 'morestories': {
          componentReturned = (
            <div className={s.moreStories}>{sectionItem.name}</div>
          );
          break;
        }
        case 'mostanalytics': {
          componentReturned = (
            <MostAnalytics
              data={sectionItem}
              isWapView={params?.isWapView}
              userData={userData}
            />
          );
          break;
        }
        default: {
          componentReturned = null;
        }
      }

      return componentReturned;
    })
  );
}
const cachedResultIfPresent = (function getCachedResultIfAvailable() {
  let cachedData = { geo: {}, userData: {} };
  return data => {
    if (!_isEqual(cachedData, data)) {
      cachedData = data;
    }

    return cachedData;
  };
})();

const mapStateToProps = state => ({
  homePageData: _get(state.toiplushome.contentsData, 'sections', []),
  userData: cachedResultIfPresent({
    userData: _get(state, 'login.userData', {}),
    geo: _get(state, 'geo', null),
  })?.userData,
  peEntryNudgeData: _get(state.translationConfig.nudges, 'peEntryNudge', {}),
  geo: cachedResultIfPresent({
    userData: _get(state, 'login.userData', {}),
    geo: _get(state, 'geo', null),
  })?.geo,
  // utilityBeltData: state.utilityBelt?.utilityBeltData,
});

// CARD-3692: temporary disabled
// const mapDispatchtoProps = dispatch => ({
//   getUtilityData: params => {
//     dispatch(getUtilityBeltData(params));
//   },
// });
ToipHomePage.propTypes = {
  homePageData: PropTypes.arrayOf({}),
  userData: PropTypes.shape({}),
};

ToipHomePage.defaultProps = {
  homePageData: [],
  userData: undefined,
};
export default connect(mapStateToProps)(ToipHomePage);
